// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"cb17475d","304":"5d124858","453":"ecdba493","899":"53f9b8a7"}[chunkId] + ".chunk.js";
};